import {
  IDataTableV2MasterColumn,
  IDataTableV2MobileColumn,
} from "../interfaces/IDataTableV2Props";
import { datatableV2FormatText } from "./datatableV2FormatText";

// Function to generate GridColDef array based on the data keys
export const generateDataTableV2ColDefs = (
  masterColumns: IDataTableV2MasterColumn[],
  excludeColumnsInSearch: string[],
) => {
  return masterColumns
    .filter(
      (x) =>
        x.fieldName !== "" && !excludeColumnsInSearch.includes(x.fieldName),
    )
    .map((item) => ({
      label: datatableV2FormatText(item.fieldName),
      value: item.fieldName,
    }));
};

export const generateMobileDataTableV2ColDefs = (
  mobileColumns: IDataTableV2MobileColumn,
  excludeColumnsInSearch: string[],
) => {
  const mobileFields: string[] = [];

  // Extract fields from mobile column configuration
  if (mobileColumns.headingColumn?.fieldName) {
    mobileFields.push(mobileColumns.headingColumn.fieldName);
  }

  if (mobileColumns.rightHeadingColumn?.fieldName) {
    mobileFields.push(mobileColumns.rightHeadingColumn.fieldName);
  }

  // Process subsection columns
  mobileColumns.subSectionColumn?.forEach((subSection) => {
    if (subSection.fieldName) {
      mobileFields.push(subSection.fieldName);
    }
  });

  // Process other columns
  mobileColumns.otherColumns?.forEach((otherCol) => {
    if (otherCol.fieldName) {
      mobileFields.push(otherCol.fieldName);
    }
  });

  // Filter and format the mobile columns
  return mobileFields
    .filter(
      (fieldName) =>
        fieldName !== "" && !excludeColumnsInSearch.includes(fieldName),
    )
    .map((fieldName) => ({
      label: datatableV2FormatText(fieldName),
      value: fieldName,
    }));
};
